// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"224370dd","513":"c04d7819","703":"5c63cb9f","787":"25bb7e11"}[chunkId] + ".chunk.js";
};